export default __webpack_public_path__ + "static/media/cleaning products_cat.c5c37ff7.jpg";